import React from "react";

export const BrandLogo = ({ size = "md", showTagline = false, inverse = false, withImage = true }) => {
  const sizes = {
    sm: { en: "text-base", hi: "text-[10px]", logo: "h-7", tm: "text-[10px]" },
    md: { en: "text-xl", hi: "text-[11px]", logo: "h-9", tm: "text-[11px]" },
    lg: { en: "text-3xl md:text-4xl", hi: "text-sm md:text-base", logo: "h-14 md:h-16", tm: "text-base md:text-lg" },
    xl: { en: "text-4xl md:text-6xl lg:text-7xl", hi: "text-base md:text-xl", logo: "h-20 md:h-28", tm: "text-xl md:text-3xl" },
  };
  const s = sizes[size];
  const enColor = inverse ? "#FDFCF8" : "var(--crimson)";
  const hiColor = inverse ? "rgba(253,252,248,0.85)" : "var(--gold-dark)";
  const tagColor = inverse ? "rgba(253,252,248,0.7)" : "var(--ash)";

  return (
    <div data-testid="brand-logo" className="inline-flex items-center gap-3">
      {withImage && (
        <img
          src="/branding/vedika-logo.png"
          alt="Vaidik Shadi logo"
          className={`${s.logo} w-auto shrink-0 object-contain`}
        />
      )}
      <div className="flex flex-col leading-none">
        <span
          className={`font-serif font-semibold ${s.en} tracking-tight leading-none`}
          style={{ color: enColor, letterSpacing: "0.01em" }}
        >
          Vaidik Shadi
          <span
            className={`${s.tm} font-sans font-normal mx-1`}
            style={{ color: hiColor, opacity: 0.7 }}
          >
            |
          </span>
          <span className={`font-devanagari ${s.en}`} style={{ color: enColor }}>
            वैदिक शादी
          </span>
        </span>
        <span
          className={`font-sans ${s.hi} mt-1 leading-none`}
          style={{ color: tagColor, letterSpacing: "0.03em" }}
        >
          An Initiative of Vedika Sanskritik Bandhan
        </span>
        {showTagline && (
          <span
            className="font-devanagari mt-2 text-sm md:text-base"
            style={{ color: tagColor, letterSpacing: "0.03em" }}
          >
            परंपरा और विश्वास का अटूट संगम
          </span>
        )}
      </div>
    </div>
  );
};

export default BrandLogo;
